import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

function removePreviewBadge() {
  const selectors = [
    '#emergent-badge',
    '[id*="emergent-badge"]',
    '[class*="emergent-badge"]',
    'a[href*="emergent.sh"]',
    'a[href*="emergentagent"]',
    'iframe[src*="emergent"]'
  ];

  selectors.forEach((selector) => {
    document.querySelectorAll(selector).forEach((el) => el.remove());
  });

  document.querySelectorAll('div, a, span').forEach((el) => {
    if (el.children.length === 0 && el.textContent && el.textContent.includes('Made with Emergent')) {
      let container = el;
      while (container.parentElement && container.parentElement !== document.body && container.parentElement !== document.documentElement) {
        if (container.parentElement.children.length === 1) {
          container = container.parentElement;
        } else {
          break;
        }
      }
      container.remove();
    }
  });
}

if (typeof window !== "undefined") {
  removePreviewBadge();
  if (document.documentElement) {
    new MutationObserver(removePreviewBadge).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
